<dx-popup *ngIf="this.visible" [visible]="this.visible" title="Hedging Assets" [showTitle]="true" [showCloseButton]="true"
          [width]="920" height="auto" [maxWidth]="'95vw'" [maxHeight]="'90vh'" [resizeEnabled]="false"
          [wrapperAttr]="{class: 'pha-hedge-products-popup'}" [closeOnOutsideClick]="false" (onHiding)="this.close()">
  <div *dxTemplate="let data of 'content'" class="hedge-products">
    <div class="product-columns">
      <section *ngFor="let column of this.columns" class="product-column" [attr.aria-label]="column.heading">
        <h2>{{ column.heading }}</h2>
        <table>
          <thead><tr><th>Ticker / Product</th><th>Price</th><th>Contract Value</th></tr></thead>
          <tbody>
            <ng-container *ngFor="let group of column.groups">
              <tr *ngIf="group.category" class="category"><td colspan="3">{{ group.category }}</td></tr>
              <tr *ngIf="group.tickers.length" class="settlement"><td colspan="3">{{ group.settlement }}</td></tr>
              <tr *ngFor="let ticker of group.tickers">
                <td><div class="ticker">{{ ticker }}</div><div class="name">{{ this.rows[ticker]?.name }}</div></td>
                <td>{{ this.rows[ticker]?.price === null ? '—' : (this.rows[ticker]?.price | currency:'USD':'symbol':'1.2-2') }}</td>
                <td>{{ this.rows[ticker]?.contractValue === null ? '—' : (this.rows[ticker]?.contractValue | currency:'USD':'symbol':'1.2-2') }}</td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </section>
    </div>
    <div class="footer"><dx-button text="Close" [width]="80" (onClick)="this.close()"></dx-button></div>
  </div>
</dx-popup>
